module.exports = __webpack_public_path__ + "img/GTM.27ae7984.png";